<!--
 * @Author: chaixueyuan chaixueyuan@huan.tv
 * @Date: 2023-10-31 15:38:20
 * @LastEditors: chaixueyuan chaixueyuan@huan.tv
 * @LastEditTime: 2023-11-06 11:09:52
 * @FilePath: /fwz/bdwph5/src/components/pageh.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
<div>
  <div class="bg" v-if="flag">
    <img class="bgimg" src="../assets/bg.png" />
    <img class="btnimg" src="../assets/btn.png" @click="mClick" />
  </div>
  <div class="bg_w" v-if="!flag">
    <img class="bg_img" src="../assets/bgw.png" />
    <div class="w_bx" @click="wClick">
      
    </div>
  </div>
</div>
  
</template>

<script>

export default {
  name: "pay",
  data() {
    return {
      flag: true
    };
  },
  created () {
    this.watchWindowSize()
    window.addEventListener("resize", this.watchWindowSize);
  },
  mounted() {
  },
  props: {},
  components: {},
  methods: {
    wClick(){
      window.location.href = 'http://qcloudcdn.a311.ottcn.com/baidu_file/%E7%99%BE%E5%BA%A6%E7%BD%91%E7%9B%98%E7%9B%B8%E5%86%8C_2.5.1042.apk'
    },
    mClick(){
      window.location.href = 'https://pan.baidu.com/s/1rw0OGXb4qHFbea7nDf5iPQ?pwd=6666'
    },
    watchWindowSize(){
      var w = document.documentElement.clientWidth;
      if(w > 800){
        this.flag = false
      }else {
        this.flag = true
      }
    }
  }
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg{
  width: 100%;
  height:100%;
  position: relative;
}

.bgimg{
  width: 100%;
  height:100%;
  margin-top:-66px;
}
.btnimg{
  width:9.6rem;
  height:3.2rem;
  position: absolute;
  top:28.9rem;
  left:5.8rem;
  z-index: 100;
}
.bg_img{
  width: 100%;
}
.w_bx{
  width: 100%;
  height:34rem;
  margin:auto;
  /* border:1px solid #000; */
  position: absolute;
  z-index: 100;
  top:14rem;
  left:0;
}
.w_btnimg{
  width: 178px;
  height:52px;
  position: absolute;
  left:12%;
  top:12%;
}
</style>




// WEBPACK FOOTER //
// src/components/pageh.vue